import React, { useState, useEffect } from "react";
import loader from "../../Assets/loaderTransaparent.gif";
import { bots } from "../../Redux/actions/dashboard";
import stringToDate from "../../Utilities/stringToDate";
import timeConversion from  "../../Utilities/timeConversion";
import EllipsisWithTooltip from 'react-ellipsis-with-tooltip';
import "./index.css";


function ActionFlows(props) {

    let [actionFlows, setActionFlows] = useState([]);
    let [count, setCount] = useState(0);
    let [loading,setLoading] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            let data = await bots();
            let arr=[]
            if(data && data.data.length > 0) {
                if(data.data.length>5){
                    data.data.forEach((item,ind) => {
                        if(ind < 5 || ind===4){
                            arr.push( item)
                        }
                    });
                    setActionFlows(arr)
                    setCount(arr.length)
                } else {
                    setActionFlows(data.data)
                    setCount(data.data.length)
                }
            }
            setLoading(false);
        };
        fetchData();
    },[])

    return (
        <div className="main-content">
            <div className="total">
                <div className="row">
                    <div className="col-md-12">
                        <div  className="card-white">
                            <div className="data-block">
                                <div className="db-title">
                                    <p>TOP {count} ACTION FLOWS</p>
                                </div>
                                <div className="list-table table-responsive">
                                    <table className="action-table">
                                        <thead >
                                            <tr>
                                                <th>Action Flows</th>
                                                <th>Instances</th>
                                                <th>ID</th>
                                                <th>Created Date</th>
                                                <th>Machine Hours</th>
                                                {/* <th>Task Automated</th> */}
                                                <th>Created By</th>
                                            </tr>
                                        </thead >
                                        <tbody>
                                        {actionFlows.length>0? actionFlows.map((obj, ind) => { 
                                            return(
                                                <tr>
                                                    <td>{obj.name}</td>
                                                    <td>{obj.instances_count}</td>
                                                    <td>{obj["TF_BOT_VERSION.bot_id"]}</td>
                                                    <td>{stringToDate(obj["TF_BOT_VERSION.created_at"].split("T")[0])}</td>
                                                    <td>
                                                    <span className="tag-1 initializing-1">{obj.totalExecutionTime?timeConversion(obj.totalExecutionTime):"0"}HRS</span></td>
                                                    {/* <td></td> */}
                                                    <td>{obj.email.length>2?<EllipsisWithTooltip >{obj.email}</EllipsisWithTooltip>:<div>{obj.email}</div>}</td>
                                                </tr>
                                            )}):loading?
                                            <div className="main-content">
                                                <div style={{ textAlign: "center", marginTop: "20%" ,marginLeft:"350%"}}>
                                                    <img src={loader} width="100" alt="loading"></img>
                                                </div>
                                            </div>:
                                            <div className="main-content">
                                              <div className="no-data">
                                                <p>You don’t have any Action Flows yet</p>
                                              </div>
                                            </div>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ActionFlows;
